<script setup>

const router = useRouter()
const localePath = useLocalePath()

const props = defineProps({
  value: {
    type: String,
  },
})

const emit = defineEmits(['clickAnchor'])

const onClick = (event) => {
	// audio intercept
	if (event.target.getAttribute('href')) {
		const href = event.target.getAttribute('href')
		const target = event.target.getAttribute('target') ?? '_blank'

		if (href.includes('/alba/') || href.includes('/albums/')) {
			const hrefParts = href.split('/')
			router.push(
				localePath({
					name: 'album-slug-audio',
					params: {
						slug: hrefParts[2],
						audio: hrefParts[3]
					}
				})
			)
		} else if (href.includes('#')) {
			emit('clickAnchor', href)
		} else {
			window.open(href, target)
		}
	}
}

</script>

<template>

	<div @click.prevent="onClick" class="dark:text-light text-dark perex light" v-html="value" />

</template>

<style lang="scss" scoped>
	:deep(a) {
		display: inline-block;
		position: relative;
		word-break: break-all;
		text-decoration: underline;

		@media (min-width: 768px) {
			text-decoration: none;
		}

		&::after {
			position: absolute;
			display: none;
			content: '';
			width: 100%;
			height: 1px;
			background: currentColor;
			top: 85%;
			left: 0;
			pointer-events: none;
			transform-origin: 100% 50%;
			transform: scale3d(1, 1, 1);
			transition: transform 0.3s;

			@media (min-width: 768px) {
				display: inline-block;
			}
		}

		&:hover {
			text-decoration: none;
			&::after {
				transform-origin: 0% 50%;
				transform: scale3d(0, 1, 1);
			}
		}
	}

	:deep(p) {
		margin-bottom: 48px;
	}
</style>